import { Typography } from "@material-ui/core"

const Private = (props) => {

  return ( <>
    <Typography>
      Your song is yours to share however you’d like! Play it at your wedding, post it on social media, or send it to family and friends. Just keep in mind that we retain the rights to all songs, which means we might feature them in our portfolio, advertising, or streaming platforms. If you’d prefer to keep your song completely private, just let us know—we won’t share it without your permission!
    </Typography>
  </> )
}

export default Private
